// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__D8WId","right":"styles_right__1HgAD"};